export const SEND_PARAMETER = 'send';
export const CONTEXT_SEND_PARAMETER = '$send';
